var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_18108_873",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_18108_873",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAENUlEQVR4nO3cv28cRRTA8e+7210U4vwFNmClAlukAFuK0kXCpkjPHxCbykQKClEaYskKDYImsqw0dv4AaiKBjUSHIjtNIDZUxPxsKRIbsrP2ozhHWDG62V+3t3f7PuXqzdzTjG5n385owRhjjDHGGGOMMcYYY4wxxphhJlkb6GY0ieg8MAOMA6dLz6oqLhiTC3//cfyS3j81Rjv5LUMve8AusM6BrMr5eCdLCq20gbpNpFvhMqIPgavAJIM8+ACRu3ziWtvNZezlNJ2x+JC2fq+b4W19QJi2cap/gG4TsR/eA97JmFzdJajeIgnXAAjdPMjHQFCw3w3EXZIpnC8w3QRshcvABwWTahbhtky5q/4wj6N7/kOgXUpizZHQknPydvxjtyD/GtDS97HBzyPgUOd9QWkW4ZkSkmmqWV+AfwKUV0pJpZ4SRG/SDkdxwRiii0BSYv+v+QLSrPZnSkiknkSXZCr55NiY39LNQBBZKukXvGOXug4YSq3o7olrQbRaaQpV/thAiLXSMWn2BBzGJ6ve7JVwIUUrvsGmsqibgfxPJVwZfyG2FWoViQwrmXZdx7jZt6AasAnoM5uAPmv6BPS6EvZq9lNQ7ythr2b/A6wSriGrhCs0EJVw5EZ4Fo0jOoswjzJRQV7V6E0lvA2sorLBS/GuLzjTsRT9gjZnwwWUzyH9zn9DxMA1Hrs78h4HaRtlPhcEoFvBDMg9bBKei0EvyXTyTdaGudYAmU42UK7naTukruUZfCiyCO+5FaDrjn9DbPPY3cnbOPcEyEUSRCt9Zu6BMirh1Sz3/BcVq4S1tQ4D/La6jEr4QNaLpFCsDngW/1Kofb+VUQmfiX8tlEKRxgT5nqJqLWsl/FexMSg2Ae3o1ULt+62MSjgqNgbF1gA5fBcd4D9BGZWw6Cyd6jeX3KOn3xIwEv4AvJ63j6Eg7PCzO5f3SSj/LWgkvELTBx9AmeBsuJC3eb5XEQ+CWVS+xF5FPOeOXkVsZG2Y7WVc57ZzBfgUG/wXOZTr7LkVuZi+mPOfC9pmhP1o/GjBnQPeKJRmvSSILtGK7vKPCpG7jMoiRR5OhB3QNbS1zsvxrkzytHu4x1AfzBK92amE/6ObwWKZe8J2MKsb2xOuIdsTrtBA7AkPMzsdPfxsEa45m4A+swnos6ZPgJ2O7is7Hd1nVgnXkFXCFRqQSvgJw/q9iN5Xwk98AWkq4Ud0volmsnsk0+7NbgFpbkGFTn41mshXvhD/BBzIKuQ/+9hgCbDmC/JOgJyPd1BWSkmpWZZlKv7JF5TuKajlPgIy7/gPgB5VwrKOuBupItN22fkYafgZygLDUkGXvyecAMuIu5Hmm6GQ59PF96MJ2jpH54N048BI1j5qox2Oylv7fx6/pN+dGiVMfs/Qy1NgF+Vr2rLm+0ylMcYYY4wxxhhjjDHGGGOMMc3yL+vNcga28x0/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketup);
export default __webpack_public_path__ + "static/media/ticketup.d9f97f9807dccbec07c219d648f712ac.svg";
export { ForwardRef as ReactComponent };